export const incidentUrl = (id) => `${window.location.origin}/?incident=${id}`;

export const focusIncident = (id, attempts = 20) => {
  const el = document.getElementById(`incident-${id}`);
  if (!el) {
    if (attempts > 0) setTimeout(() => focusIncident(id, attempts - 1), 150);
    return false;
  }
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.add("card-flash");
  setTimeout(() => el.classList.remove("card-flash"), 1800);
  return true;
};
